class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.onSubmitHandler = this.onSubmit.bind(this);
  }

  connectedCallback() {
    this.addEventListener('submit', this.onSubmitHandler);
    this.performRecommendations();
  }

  performRecommendations() {
    const recommendations = this.querySelector(
      '[data-recommendations]'
    );
    if (!recommendations) return;
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const recommendationsHMTL = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('[data-recommendations]').innerHTML;
        if (!recommendationsHMTL) return;
        this.classList.remove('hidden');
        recommendations.innerHTML = recommendationsHMTL;
        this.initSlider();
      });
  }

  onSubmit(event) {
    const form = event.target.closest('[data-cart-recommendation-form]');
    if (!form) return;

    event.preventDefault();
    this.addRecommendation(form);
  }

  async addRecommendation(form) {
    const submitButton = form.querySelector('[type="submit"]');
    const buttonText = form.querySelector('[data-cart-recommendation-button-text]');
    const defaultText = buttonText?.textContent;
    const cartDrawer = document.querySelector('cart-drawer');
    const formData = new FormData(form);
    const sectionsToRender = cartDrawer?.getSectionsToRender?.() || [];
    const config = fetchConfig('javascript');

    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    if (sectionsToRender.length) {
      formData.append('sections', sectionsToRender.map(section => section.section));
      formData.append('sections_url', window.location.pathname);
    }

    config.body = formData;
    submitButton?.setAttribute('disabled', 'disabled');
    form.classList.remove('has-error');

    if (buttonText) {
      buttonText.textContent = window.theme?.strings?.loading || defaultText;
    }

    try {
      const response = await fetch(`${routes.cart_add_url}`, config);
      const parsedResponse = await response.json();

      if (!response.ok || parsedResponse.status) {
        throw new Error(parsedResponse.description || window.theme?.strings?.cartError || 'Cart error');
      }

      if (cartDrawer && parsedResponse.sections) {
        cartDrawer.renderContents(parsedResponse, true);
      } else {
        window.location.href = '/cart';
      }

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: parsedResponse
        })
      );
    } catch (error) {
      console.error(error);
      form.classList.add('has-error');
    } finally {
      submitButton?.removeAttribute('disabled');

      if (buttonText) {
        buttonText.textContent = defaultText;
      }
    }
  }

  initSlider() {
    this.slider = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 'auto',
      spaceBetween: 8
    });
  }
}

customElements.define('cart-recommendations', CartRecommendations);
